module.exports = __webpack_public_path__ + "img/hangye2.4f03d5a4.png";